/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, Injector, Input, OnInit } from '@angular/core';
import { BaseAccountFormComponent } from '../base-account-form.component';

@Component({
  selector: 'tgv-contact',
  standalone: false,
  templateUrl: './contact.component.html'
})
export class ContactComponent extends BaseAccountFormComponent implements OnInit {
  @Input() hasName = false;
  @Input() isContact = false;
  @Input() isDisableField = 'false';
  phoneMask: string;
  readonly phoneMasks = {
    8: '9999-9999999',
    9: '99999-999999',
    10: '(99) 9999-99999',
    11: '(99) 99999-9999'
  };

  readonly emailsPattern = "^([\\w._%+-]+@[\\w.-]+\\.[a-zA-Z]{2,})(;[\\w._%+-]+@[\\w.-]+\\.[a-zA-Z]{2,})*$";

  constructor(override injector: Injector) {
    super(injector);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    if (!this.isContact) {
      this.onInitPhoneMask();
    }
  }

  getNameOfFields(): string[] {
    if (!this.isContact) {
      return ['contact', 'email', 'phone'];
    } else {
      return ['code', 'name', 'email'];
    }
  }

  onInitPhoneMask(): void {
    this.phoneMask = this.phoneMasks[this.form.get('phone')?.value?.length] ?? this.phoneMask;
  }

  onChangePhoneMask(phone: string): void {
    if (phone !== undefined) {
      this.phoneMask = this.phoneMasks[phone.length] ?? this.phoneMask;
    }
  }
}
